import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styles from './Questionnaire.module.css';
import { CancelSection, ResultsSection } from '../DiscountOffer/components';
import FeedbackSection from './components/FeedbackSection';
import CancellationSection from '../SubscriptionDowngrade/components/CancellationSection';
 
const Questionnaire = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [selectedReason, setSelectedReason] = useState('no_longer_need');
    const [loading, setLoading] = useState(false);

    const feedbackOptions = [
        { value: 'no_longer_need', label: t('feedback.options.no_longer_needed') },
        { value: 'better_alternative', label: t('feedback.options.better_alternative') },
        { value: 'lack_of_matches', label: t('feedback.options.lack_of_matches') },
        { value: 'budget_constraints', label: t('feedback.options.budget_constraints') },
        { value: 'other', label: t('feedback.options.other') }
    ];

    const handleFeedbackChange = (value) => {
        setSelectedReason(value);
    };

    const handleProceedToCancel = () => {
        setLoading(true);
         try {
             navigate('/subscription-pause');    
        } catch (error) {
             window.location.href = '/subscription-pause';
        } finally {
        }
        setLoading(false);
    };
    return (
        <div className={styles.container}>
            <FeedbackSection 
                selectedReason={selectedReason}
                onFeedbackChange={handleFeedbackChange}
                onProceedToCancel={handleProceedToCancel}
                feedbackOptions={feedbackOptions}
            />

            <ResultsSection />

            <CancellationSection 
                handleCancelSubscription={handleProceedToCancel}
                loading={loading}
                to={'/subscription-pause'}
            />
        </div>
    );
};

export default Questionnaire; 